import LFCBaseCharts from '_components/charts/base/LFCBaseCharts';
import {useTranslation} from 'react-i18next';

/**
 * 引数
 */
interface Props {
  title: string;
  source: any;
  x: {
    dsColumn: string;
  };
  yAxis: {
    type: string;
    name: any;
    dsColumn: any;
  };
  series?: string;
  grid?: {
    top?: number | string;
    bottom?: number | string;
    left?: number | string;
    right?: number | string;
  };
  color?: string | {};
  exportData?: any;
  exportFields?: any;
  exportFilename?: string;
  mapName?: string;
  onClick?: any;
  zoomCharts?: any;
  zoomChartsClose?: any;
  zoomChartId?: string;
  zoomStatus?: boolean;
  zoomedChartId?: string;
}

/**
 * LFCChartsBar
 * @param props
 * @returns
 */
const LFCChartsLineHoleCompareWithToleranceType = (props: Props) => {
  const {t} = useTranslation();
  if (props.source !== undefined) {
    return (
      <div style={{width: '100%'}}>
        <LFCBaseCharts
          option={{
            title: [
              {
                text: props.title
              }
            ],
            grid: props.grid
              ? props.grid
              : {
                  left: '8%',
                  right: '5%',
                  bottom: '22%',
                  top: '20%'
                },
            legend: {
              type: 'scroll',
              bottom: 0,
              itemWidth: 10,
              textStyle: {
                fontSize: 10
              }
            },
            tooltip: {
              trigger: 'axis',
              position: (point: any, params: any, dom: any, rect: any, size: any) => {
                // fixed at top
                return [point[0] + 20, '10%'];
              },
              formatter: (prm: any) => {
                return (
                  t('計測日時') +
                  ':' +
                  prm[0].value[3] +
                  '<br/>' +
                  t('検査部位') +
                  ':' +
                  prm[0].value[2] +
                  '<br/>' +
                  prm[0].marker +
                  prm[0].seriesName +
                  ':' +
                  (Number(prm[0].value[4]) ? Number(prm[0].value[4]).toFixed(3) : '')
                );
              }
            },
            dataZoom: [
              {
                type: 'inside'
              }
            ],
            color: props.color ? props.color : null,
            dataset: {
              source: props.source !== null ? props.source : []
            },
            xAxis: [
              {
                type: 'category',
                axisLabel: {
                  // interval: 0,
                  rotate: '45',
                  fontSize: 10
                }
              }
            ],
            yAxis: [
              {
                type: 'value',
                name: props.yAxis.name,
                axisLabel: {
                  // interval: 0,
                  // rotate: "45",
                  fontSize: 10
                }
              }
            ],
            series: [
              {
                type: props.yAxis.type,
                name: props.yAxis.name,
                xAxisIndex: 0,
                yAxisIndex: 0,
                encode: {
                  x: props.x.dsColumn,
                  y: props.yAxis.dsColumn
                }
              }
            ]
          }}
          exportData={props.exportData}
          exportFields={props.exportFields}
          exportFilename={props.exportFilename}
          onEvents={{
            click: (params: any) => {
              if (props.onClick != null) {
                params.mapName = props.mapName;
                props.onClick(props.source.serial[params.dataIndex]);
              }
            }
          }}
          zoomCharts={props.zoomCharts ? props.zoomCharts : undefined}
          zoomChartsClose={props.zoomChartsClose ? props.zoomChartsClose : undefined}
          zoomChartId={props.zoomChartId ? props.zoomChartId : undefined}
          zoomStatus={props.zoomChartId === props.zoomedChartId}
        />
      </div>
    );
  } else {
    return <></>;
  }
};
export default LFCChartsLineHoleCompareWithToleranceType;
